
import React, { useState } from 'react';
import './Tooltip.css';

const TooltipLocal = ({ text, children, position = "top" }) => {
  const [visible, setVisible] = useState(false);

  const showTooltip = () => setVisible(true);
  const hideTooltip = () => setVisible(false);

  return (
    <div 
      className="tooltip-container"
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
    >
      {children}
      {visible && (
        <div className={`tooltip-box tooltip-${position}`}>
            {text}
        </div>
      )}
    </div>
  );
};

export default TooltipLocal;
